import keyBy from 'lodash/keyBy';
import { sortDescBy } from '@seeneco-ui/core/utils/sort';

import {
	IBusinessState,
	createSelector,
	createAsyncSelector
} from '../../../flux';


const selectAsyncCashManagementSystems = createAsyncSelector({
	get: state => state.$business.integrations.cms,
	selector: createSelector(
		(state: IBusinessState) => state.$business.integrations.cms.item,
		item => item,
	),
});

const selectAsyncExternalSystemAccounts = createAsyncSelector({
	get: state => state.$business.integrations.externalSystemAccounts,
	selector: createSelector(
		(state: IBusinessState) => state.$business.integrations.externalSystemAccounts.item,
		item => item,
	),
});

const selectAsyncExternalSubsystemInstances = createAsyncSelector({
	get: state => state.$business.integrations.externalSubsystemInstances,
	selector: createSelector(
		(state: IBusinessState) => state.$business.integrations.externalSubsystemInstances.item,
		item => item,
	),
});

const selectAsyncRemoteExternalServices = createAsyncSelector({
	get: state => state.$business.integrations.remoteExternalServices,
	selector: createSelector(
		(state: IBusinessState) => state.$business.integrations.remoteExternalServices.item,
		item => item,
	),
});

const selectCMSByGUIDMap = createSelector(
	(state: IBusinessState) => selectAsyncCashManagementSystems.selectItem(state),
	(cmsMap: Record<string, CashManagementSystem>) => cmsMap ? keyBy(cmsMap, el => el.SubsystemInstanceGUID) : null,
);

const selectExternalSystemAccountsList = createSelector(
	(state: IBusinessState) => state.$business.integrations.externalSystemAccounts.item,
	accountMap => {
		const list = accountMap ? Object.keys(accountMap).map(key => accountMap[key]) : [];
		const sortedList = sortDescBy(list, [
			{ fn: item => item.ExternalSSInstanceID },
			{ fn: item => item.ID },
		]);

		return sortedList;
	}
);

const selectExternalSubSystemInstancesByIDMap = createSelector(
	(state: IBusinessState) => selectAsyncExternalSubsystemInstances.selectItem(state),
	(ssInstanceMap: Record<string, SubsystemInstance>) => keyBy(ssInstanceMap, el => el.ID),
);

export const integrationsSelectorsPack = {
	selectAsyncCashManagementSystems,
	selectAsyncExternalSystemAccounts,
	selectAsyncExternalSubsystemInstances,
	selectAsyncRemoteExternalServices,
	selectCMSByGUIDMap,
	selectExternalSystemAccountsList,
	selectExternalSubSystemInstancesByIDMap,
};
